import Model, { attr } from '@ember-data/model';

import type { ImageCropData } from 'webapp-types';
import { ReportLayout } from 'webapp/enums/enums';
import type { VerificationInfo } from 'webapp/utils/verification';

export default class ReportRecord extends Model {
	@attr('string') title!: string;
	@attr('string') color!: string; // first report slide color
	@attr('number', { defaultValue: 1 }) themeId!: number; // first report slide color theme id (const/theme-config)
	@attr('string') image!: string; // first report slide image url or pageless report thumbnail to preview (cdn)
	@attr('number') slideCount!: number;
	@attr('number') ownerId!: number | null;
	@attr('number') created!: number;
	@attr('number') createdBy!: number;
	@attr('number') modified!: number | null;
	@attr('number') order!: number;
	@attr('boolean') favorite!: boolean;
	@attr('number') deleted!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	tags!: number[];
	@attr('number', { defaultValue: ReportLayout.PAGELESS }) layout!: ReportLayout;

	// Templates stuff
	@attr('number') templateId!: number;
	@attr('number') spaceId!: number;
	@attr('number') originateFrom!: number;
	// Sharing stuff
	@attr('string') token!: string;
	@attr('boolean', { defaultValue: false }) declare isPublicEnabled: boolean; // Defines if an existing token should render on a datawall or not
	@attr('boolean', { defaultValue: true }) allowAnonymousDateRangeEdit!: boolean;
	@attr('boolean', { defaultValue: true }) allowAnonymousFilterEdit!: boolean;
	@attr('string') password!: string; // datawall password
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	restrictIps!: string[]; // restrict to IPs
	@attr('string') cover?: string | null;
	@attr('string') coverOriginal?: string | null;
	@attr('object') coverCrop?: ImageCropData | null;

	@attr('object') verificationInfo?: VerificationInfo;

	// only for internal webapp use
	@attr('boolean') newBadge!: boolean;

	// flag used on BE only for onboarding (creating report from sample template)
	// https://app.asana.com/1/7582066485656/project/1138028810573038/task/1213262067285232
	@attr('boolean') isSample!: boolean;
}
